import { render, staticRenderFns } from "./BannerGold.vue?vue&type=template&id=4405aecd&scoped=true&"
import script from "./BannerGold.vue?vue&type=script&lang=js&"
export * from "./BannerGold.vue?vue&type=script&lang=js&"
import style0 from "./BannerGold.vue?vue&type=style&index=0&id=4405aecd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4405aecd",
  null
  
)

export default component.exports